window.creationsShowcaseHandler = () => {
  document.addEventListener('DOMContentLoaded', () => {
    creationsShowcaseEvents();
  });

  const creationsShowcaseEvents = () => {
    const sliders = document.querySelectorAll('.jsCreationsShowcaseSlider');

    sliders.forEach((slider) => {
      const section = slider.closest('.section');
      const filters = section ? Array.from(section.querySelectorAll('.jsCreationsShowcaseFilter')) : [];
      const navSlider = section ? section.querySelector('.jsCreationsShowcaseNav') : null;

      $(slider).slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 800,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: true,
        asNavFor: navSlider ? $(navSlider) : null,
      });

      // Base (unfiltered) nav thumbnail counts, captured from the untouched DOM
      // before slick wraps/reorders anything, so filtering can size the nav
      // slider to how many slides a given style actually has instead of a
      // fixed count. Without this, filtering to a style with fewer images than
      // slidesToShow combined with centerMode renders duplicated/cloned
      // thumbnails and broken centering.
      const navSlideStyles = navSlider
        ? Array.from(navSlider.children).map((el) => (el.dataset.style || '').split(' ').filter(Boolean))
        : [];
      const countNavSlides = (style) =>
        (style ? navSlideStyles.filter((slideStyles) => slideStyles.includes(style)) : navSlideStyles).length;

      const NAV_SLIDES_TO_SHOW = { base: 6, 992: 5, 768: 4 };

      const buildNavSettings = (count) => {
        const safeCount = Math.max(count, 1);
        // When every thumbnail already fits within slidesToShow, there's nothing
        // to scroll to: with slick's default infinite:true it would still pad
        // the track with cloned slides and shift position on navigation, making
        // the strip appear to move even though nothing is actually off-screen.
        // Disable infinite/dragging per-breakpoint so it just sits static instead.
        const overflowsAt = (slidesToShow) => safeCount > slidesToShow;
        const baseSlidesToShow = Math.min(NAV_SLIDES_TO_SHOW.base, safeCount);
        const bp992SlidesToShow = Math.min(NAV_SLIDES_TO_SHOW[992], safeCount);
        const bp768SlidesToShow = Math.min(NAV_SLIDES_TO_SHOW[768], safeCount);

        return {
          asNavFor: $(slider),
          arrows: false,
          dots: false,
          centerMode: overflowsAt(NAV_SLIDES_TO_SHOW.base),
          infinite: overflowsAt(baseSlidesToShow),
          swipeToSlide: overflowsAt(baseSlidesToShow),
          // Slick's own focusOnSelect reads the clicked slide's data-slick-index
          // attribute and forwards it as-is to asNavFor's slideHandler. That
          // attribute is assigned once, from the slide's position among *all*
          // (unfiltered) slides, and slickFilter never renumbers it - but the
          // main slider's currentSlide/slideCount are the *filtered* count, so
          // that raw index is out of range for anything but the "All" filter
          // (e.g. clicking the last of 4 filtered thumbnails can pass index 8
          // into a 4-slide main slider, landing nowhere and rendering a blank/
          // empty slide). Bound manually below instead, off each slide's actual
          // position among the currently-filtered slides.
          focusOnSelect: false,
          slidesToShow: baseSlidesToShow,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                centerMode: false,
                infinite: overflowsAt(bp992SlidesToShow),
                swipeToSlide: overflowsAt(bp992SlidesToShow),
                slidesToShow: bp992SlidesToShow,
              },
            },
            {
              breakpoint: 768,
              settings: {
                centerMode: false,
                infinite: overflowsAt(bp768SlidesToShow),
                swipeToSlide: overflowsAt(bp768SlidesToShow),
                slidesToShow: bp768SlidesToShow,
              },
            },
          ],
        };
      };

      // Slick's getLeft() only compensates the track's translateX for slides
      // that don't fit slidesToShow; the moment slideCount <= slidesToShow (a
      // style with as few thumbnails as the strip normally shows) it zeroes
      // that compensation but still shifts the track by currentSlide * width,
      // pushing the earlier thumbnails off-screen to the left and leaving a
      // gap on the right even though every thumbnail already fits in view.
      // Patched onto the instance (not the prototype) so it only affects this
      // nav strip; re-applied on every rebuild since unslick() drops it.
      const patchNavTrackPosition = (instance) => {
        const originalGetLeft = instance.getLeft;
        instance.getLeft = function (slideIndex) {
          if (this.slideCount <= this.options.slidesToShow) return 0;
          return originalGetLeft.call(this, slideIndex);
        };
      };

      const initNavSlider = (count) => {
        if (!navSlider) return;
        const $nav = $(navSlider);
        if ($nav.hasClass('slick-initialized')) {
          // unslick() rebuilds the DOM from the instance's *current* _.$slides,
          // which after a slickFilter call only holds the previously-filtered
          // subset (slick's reinit() overwrites _.$slides to just the visible
          // slides). Restoring the full set first prevents every slide outside
          // the previous filter from being silently dropped on rebuild.
          $nav.slick('slickUnfilter');
          $nav.slick('unslick');
        }
        $nav.slick(buildNavSettings(count));
        patchNavTrackPosition($nav.slick('getSlick'));
      };

      if (navSlider) {
        // Slick clones/repositions thumbnail slides after init, which the global
        // lazy-load observer can miss, so force-load anything still on the pixel
        // placeholder the same way the product gallery's thumbnail strip does.
        // Bound once on the outer element, so it also re-fires after the
        // unslick/reinit that initNavSlider does on every filter change.
        $(navSlider).on('init', function () {
          if (window.LazyLoad) {
            $(this)
              .find('img[data-src]:not(.loaded)')
              .each((index, el) => window.LazyLoad.load(el));
          }
        });

        // Replaces slick's built-in focusOnSelect (disabled above): navigate the
        // main slider to the clicked thumbnail's position among the currently
        // filtered/visible nav slides, not its stale absolute data-slick-index.
        // Delegated on the outer element so it survives the unslick/reinit that
        // initNavSlider does on every filter change.
        $(navSlider).on('click', '.creations-showcase__nav-slide', function () {
          const $slide = $(this);
          const navInstance = $(navSlider).slick('getSlick');
          if (!navInstance) return;

          let index;
          if ($slide.hasClass('slick-cloned')) {
            // Whenever there are more thumbnails than fit on screen, slick pads
            // the track with clones of the real slides for the infinite-scroll
            // wraparound - e.g. the thumbnail furthest to the left of the
            // centered active one is usually a clone, not a real slide, so
            // without this a "click the previous thumbnail" click silently did
            // nothing. Unlike real slides (see below), setupInfinite() assigns
            // clones a data-slick-index of (their real position) +/- slideCount,
            // so it can be mapped back with a single modulo.
            const rawIndex = parseInt($slide.attr('data-slick-index'), 10);
            if (Number.isNaN(rawIndex)) return;
            index = ((rawIndex % navInstance.slideCount) + navInstance.slideCount) % navInstance.slideCount;
          } else {
            // Real slides keep the data-slick-index they were assigned when the
            // (unfiltered) element set was last built, so it isn't usable as a
            // position post-filter; use where the slide actually sits among the
            // currently visible/filtered slides instead.
            index = $slide.closest('.slick-track').children('.slick-slide:not(.slick-cloned)').index($slide);
            if (index === -1) return;
          }

          $(slider).slick('slickGoTo', index);
        });

        initNavSlider(countNavSlides(''));
      }

      const resetSlider = ($el) => {
        // Slick doesn't clamp currentSlide into the new, smaller slide count when
        // filtering from a slide index autoplay has advanced past it (e.g. slide 5
        // of 8 filtered down to 2 slides), so the active fade slide can end up
        // pointing past the end and render nothing (a "black hole" instead of an
        // image). Reset the slider's internal state directly; applyFilter defers
        // this call until any in-flight fade transition has finished, so there's
        // no animation left to clamp mid-flight.
        const instance = $el.slick('getSlick');
        if (instance) {
          instance.currentSlide = 0;
          instance.animating = false;
        }
      };

      const applyFilter = (style) => {
        const run = () => {
          resetSlider($(slider));

          // slickFilter re-caches whatever slides are currently in the track, so filtering
          // twice in a row without unfiltering first would search within the previous
          // (already narrowed) subset instead of the full slide set. Always unfilter first.
          $(slider).slick('slickUnfilter');
          if (style) {
            $(slider).slick('slickFilter', `[data-style~="${style}"]`);
          }

          if (navSlider) {
            // Rebuilt (not just unfiltered) so slidesToShow/centerMode can be
            // resized to the filtered slide count.
            initNavSlider(countNavSlides(style));
            if (style) {
              $(navSlider).slick('slickFilter', `[data-style~="${style}"]`);
            }
          }
        };

        const instance = $(slider).slick('getSlick');
        if (instance && instance.animating) {
          // A fade transition may still be in-flight. Slick schedules its
          // completion via setTimeout, not a jQuery-queued animation, so
          // `.stop(true, true)` can't cancel it — resetting/filtering now
          // would leave that stale callback to fire afterwards with an
          // out-of-range index. Wait for it to finish instead.
          $(slider).one('afterChange', run);
        } else {
          run();
        }
      };

      const setActiveFilter = (activeFilter) => {
        filters.forEach((filter) => filter.classList.remove('creations-showcase__filter--active'));
        activeFilter.classList.add('creations-showcase__filter--active');
      };

      filters.forEach((filter) => {
        filter.addEventListener('click', () => {
          const style = filter.dataset.style || '';

          setActiveFilter(filter);
          applyFilter(style);

          if (style) {
            window.queryParamEvents('set', 'style', style);
          } else {
            window.queryParamEvents('delete', 'style');
          }
        });
      });

      const initialStyle = window.queryParamEvents('get', 'style');
      if (initialStyle) {
        const matchingFilter = filters.find((filter) => filter.dataset.style === initialStyle);
        if (matchingFilter) {
          setActiveFilter(matchingFilter);
          applyFilter(initialStyle);
        }
      }
    });
  };
};
